import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getLabelId } from '../utils/aria';
import StyledFormMessage from './styles';
const FormMessage = ({
  align,
  children,
  error = false,
  contextHelp = false,
  leftMargin,
  ...props
}) => /*#__PURE__*/React.createElement(StyledFormMessage, _extends({
  $align: align,
  "data-error": error,
  "data-context-help": contextHelp,
  "data-left-margin": leftMargin
}, props), children);
FormMessage.displayName = 'FormMessage';
FormMessage.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
  contextHelp: PropTypes.bool,
  leftMargin: PropTypes.string
};
export function withFormMessage() {
  return function withFormMessageWrapper(Component) {
    const WithFormMessage = /*#__PURE__*/forwardRef(({
      error,
      hint,
      'data-auto': dataAuto,
      ...props
    }, ref) => {
      const id = useMemo(() => getLabelId('form-message'), []);
      const isError = Boolean(error);
      const isHint = Boolean(!isError && hint);
      const ariaProps = {
        ...(isHint || isError ? {
          'aria-describedby': id
        } : {}),
        ...(isError ? {
          'aria-invalid': true
        } : {})
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({
        ref: ref,
        "data-auto": dataAuto
      }, props, ariaProps, {
        error: error
      })), isError && /*#__PURE__*/React.createElement(FormMessage, {
        key: error,
        id: id,
        "data-auto": dataAuto ? `${dataAuto}__errorMessage` : undefined,
        error: true
      }, error), isHint && /*#__PURE__*/React.createElement(FormMessage, {
        key: hint,
        id: id,
        "data-auto": dataAuto ? `${dataAuto}__hintMessage` : undefined
      }, hint));
    });
    WithFormMessage.displayName = `${Component.displayName || Component.name || 'Anonymous'}FormMessageWrapper`;
    return WithFormMessage;
  };
}
export default FormMessage;
//# sourceMappingURL=index.js.map